import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../styles/HeroNavbar.css";

const slides = [
  {
    id: 1,
    title: "Fueling Africa’s future",
    subtitle: "through innovation and entrepreneurship.",
    image:
      "https://images.unsplash.com/photo-1655720357872-ce227e4164ba?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  },
  {
    id: 2,
    title: "From startup to standout",
    subtitle: "we grow African businesses.",
    image: "/plan.png",
  },
];

export default function HeroSection() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="main-hero-section"
      style={{ backgroundImage: `url(${slides[index].image})` }}
    >
      <div
        className={`overlay ${index === 0 ? "overlay-left" : "overlay-right"}`}
      >
        <motion.div
          key={slides[index].id}
          className={`content ${index === 0 ? "align-left" : "align-right"}`}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -50 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="herosection-title">
            <span className="herosection-main-title">
              {slides[index].title}
            </span>
            <br />
            <span className="herosection-subtitle">
              {slides[index].subtitle}
            </span>
          </h1>
        </motion.div>
      </div>
    </section>
  );
}
